var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.downloading)?_c('v-skeleton-loader',{staticClass:"mt-2 mb-2",attrs:{"type":"image"}}):_c('div',{staticClass:"mt-2 mb-2 d-flex align-center"},[_c('img',{attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }